module.exports = __webpack_public_path__ + "img/IE-mobile-image-404@610.9cc69b58.png";